import React from 'react'
import ReactDOM from 'react-dom'
import Raven from 'raven-js'

import { CoreLayout } from './layouts/CoreLayout'
import Error from './components/Error'

export default function configureErrorHandling(
  appEl,
  window,
  ravenDsn,
  version,
) {
  window.raven = Raven.config(ravenDsn, {
    release: version,
    environment: process.env.NODE_ENV,
    autoBreadcrumbs: {
      xhr: true,
      console: true,
      dom: true,
      location: true,
    },
  }).install()

  // window.raven.setBreadcrumbCallback(console.log)

  const errorHandler = createErrorHandler(window.onerror, appEl)
  window.onerror = errorHandler

  return errorHandler
}

export function createErrorHandler(oldHandler, appEl) {
  return (...args) => {
    if (oldHandler) {
      oldHandler.apply(this, args)
    }

    console.error(args[0]);

    ReactDOM.render(
      <CoreLayout loading={false} user={null}>
        <Error error={process.env.NODE_ENV === 'development' ? args[0] : null} />
      </CoreLayout>,
      appEl,
    )
  }
}



// WEBPACK FOOTER //
// ./src/errors.jsx